import { useDispatch } from 'react-redux';

import {
  getPicklist,
  getCounting,
  getPicklistStatuses,
  getCsvResource,
  getFilterCriteria,
  setPicklistAssets,
  setFilter,
  clearState,
  getPicklistAssets,
  updatePicklistAsset,
  deletePicklistAssets,
  deletePicklist,
  checkBillOfLadingItems,
  setPicklistLooseItems,
  setPicklistAssemblies,
  deleteFileFromAsset,
  checkPicklistAssetsLocation,
  addAssemblyToPicklist
} from 'actions/picklistDetailsActions';

export function usePicklistDetailsActions() {
  const dispatch = useDispatch();

  const getPicklistAction = (id) => dispatch(getPicklist(id));
  const getCountingAction = (q) => dispatch(getCounting(q));
  const getPicklistAssetsAction = (q) => dispatch(getPicklistAssets(q));
  const getPicklistStatusesAction = () => dispatch(getPicklistStatuses());

  const getCsvResourceAction = (q) => dispatch(getCsvResource(q));

  const setPicklistAssetsAction = (data) => dispatch(setPicklistAssets(data));
  const setPicklistLooseItemsAction = (data) => dispatch(setPicklistLooseItems(data));
  const setPicklistAssembliesAction = (data) => dispatch(setPicklistAssemblies(data));

  const getFilterCriteriaAction = (q) => dispatch(getFilterCriteria(q));
  const setFilterAction = (data) => dispatch(setFilter(data));

  const deletePicklistAction = (id) => dispatch(deletePicklist(id));

  const updatePicklistAssetAction = (data) => dispatch(updatePicklistAsset(data));
  const deletePicklistAssetsAction = (data) => dispatch(deletePicklistAssets(data));

  const checkBillOfLadingItemsAction = (data) => dispatch(checkBillOfLadingItems(data));

  const deleteFileFromAssetAction = (data) => dispatch(deleteFileFromAsset(data));

  const checkPicklistAssetsLocationAction = (q) => dispatch(checkPicklistAssetsLocation(q));

  const addAssemblyToPicklistAction = (data) => dispatch(addAssemblyToPicklist(data));

  const clearStateAction = () => dispatch(clearState());

  return {
    getPicklistAction,
    getCountingAction,
    getPicklistAssetsAction,
    getPicklistStatusesAction,
    getCsvResourceAction,
    getFilterCriteriaAction,
    setPicklistAssetsAction,
    setPicklistLooseItemsAction,
    setPicklistAssembliesAction,
    setFilterAction,
    clearStateAction,
    updatePicklistAssetAction,
    deletePicklistAction,
    deletePicklistAssetsAction,
    checkBillOfLadingItemsAction,
    deleteFileFromAssetAction,
    addAssemblyToPicklistAction,
    checkPicklistAssetsLocationAction
  };
}
